import { createFileRoute } from '@tanstack/react-router';

import { ContentEditor } from '../../../@components/content-editor/ContentEditor';
import { treatmentUpdateEditorSettings } from '../../../@components/content-editor/treatmentUpdateEditorSettings';

export const Route = createFileRoute(
  '/_layout/(private)/my-treatments/$id/edit/',
)({
  component: MyTreatmentsEditDetails,
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      treatmentUpdateEditorSettings.detailsQueryOptions(params.id),
    );
  },
});

function MyTreatmentsEditDetails() {
  const { id } = Route.useParams();

  return <ContentEditor id={id} settings={treatmentUpdateEditorSettings} />;
}
